let getDisplayName = (data, type) => {
  if (type === 'ip') {
    if (data.patronymic == null) return "ИП " + data.lastName + " " + data.firstName;
    else return "ИП " + data.lastName + " " + data.firstName + " " + data.patronymic;
  } else {
    if (data.patronymic == null) return data.lastName + " " + data.firstName;
    else return data.lastName + " " + data.firstName + " " + data.patronymic;
  }
};

export default function getCounterpatiesInfoForContract(item) {
  if (item.counterparty.counterpartyType === "Legal person") {
    return {id: item.counterparty.idInDB, value: item.counterparty.shortName};
  } else if (item.counterparty.counterpartyType === "Natural person") {
    return {id: item.counterparty.idInDB, value: getDisplayName(item.counterparty)};
  } else if (item.counterparty.counterpartyType === "Sole proprietorship") {
    return {id: item.counterparty.idInDB, value: getDisplayName(item.counterparty, 'ip')};
  } else {
    throw new Error("counterpatiesInfoForContractBuilder for type " + item.counterparty.counterpartyType + "is not implimented");
  }
}
